import { Injectable } from '@angular/core';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';

@Injectable({
    providedIn: 'root'
})
export class ColorService {
    public static $name = 'clColorService';

    constructor(private themeService: ThemeService) {
    }

    getContrastLabelColor(): string {
        const dark = 'rgba(255, 255, 255, 0.87)';
        const light = 'rgba(0, 0, 0, 0.87)';

        return this.themeService.getTheme() === 'casDark' ? dark : light;
    }
}